import axiosInstance from "../axios_instance";

export async function getUserPaymentsInfo(userID) {
  try {
    const url = `bankAndPayments/${userID}`
    return await axiosInstance.get(url);
  } catch (error) {
    return error;
  }
}

export async function createUpiID(userID, body) {
  try {
    const url = `bankAndPayments/${userID}/upi`
    return await axiosInstance.post(url, body);
  } catch (error) {
    return error;
  }
}

export async function updateUpiID(userID, body) {
  try {
    const url = `bankAndPayments/${userID}/upi/${body?.upiId}`
    return await axiosInstance.put(url, body);
  } catch (error) {
    return error;
  }
}
